import { Navigate } from "react-router-dom";
const Protected = ({ isAllowed, children }) => {
 if (!isAllowed) {
 return <Navigate to="/" replace />;
 }
 return children;
};
export default Protected;